import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Auth uses httpOnly cookie set by backend on login/register.
// withCredentials makes axios send/receive that cookie cross-origin.
const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || 'Beklenmeyen bir hata oluştu.';
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(' ');
  if (typeof d === 'object' && d.msg) return d.msg;
  return String(d);
}

export const authAPI = {
  register: (email, password, name, phone) => api.post('/auth/register', { email, password, name, phone }),
  login: (email, password) => api.post('/auth/login', { email, password }),
  me: () => api.get('/auth/me'),
  logout: () => api.post('/auth/logout'),
  resendVerification: () => api.post('/auth/resend-verification'),
  verifyEmail: (token) => api.get('/auth/verify-email', { params: { token } }),
};

export const balanceAPI = {
  getBalance: () => api.get('/balance'),
  getIbanInfo: () => api.get('/payment/iban'),
  getShopierProducts: () => api.get('/payment/shopier/products'),
  uploadDekont: (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return api.post('/payment/upload-dekont', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  createBalanceRequest: (amount, dekontUrl, note) =>
    api.post('/payment/balance-request', { amount, dekont_url: dekontUrl, note }),
  myBalanceRequests: () => api.get('/payment/balance-request/mine'),
};

export const gethinhAPI = {
  getProviders: () => api.get('/gethinh/providers'),
  getPricing: () => api.get('/gethinh/pricing'),
  getPublicStats: () => api.get('/public/stats'),
  preview: (link) => api.post('/gethinh/preview', { link }),
  quote: (link) => api.post('/gethinh/quote', { link }),
  download: (link) => api.post('/gethinh/download', { link }),
  getHistory: () => api.get('/downloads/history'),
};

export const profileAPI = {
  update: (patch) => api.post('/profile/update', patch),
  changePassword: (current_password, new_password) =>
    api.post('/profile/change-password', { current_password, new_password }),
  freeze: () => api.post('/profile/freeze'),
  delete: (password) => api.post('/profile/delete', { password }),
};

export const contactAPI = {
  submit: (name, email, subject, message) => api.post('/contact', { name, email, subject, message }),
};

export const adminAPI = {
  stats: () => api.get('/admin/stats'),
  listUsers: () => api.get('/admin/users'),
  createUser: (payload) => api.post('/admin/users', payload),
  addBalance: (userId, amount, note) =>
    api.post('/admin/users/add-balance', { user_id: userId, amount, note }),
  freezeUser: (userId) => api.post(`/admin/users/${userId}/freeze`),
  unfreezeUser: (userId) => api.post(`/admin/users/${userId}/unfreeze`),
  deleteUser: (userId) => api.delete(`/admin/users/${userId}`),
  listRequests: (status) => api.get('/admin/requests', { params: status ? { status } : {} }),
  approveRequest: (id, note) => api.post(`/admin/requests/${id}/approve`, { note }),
  rejectRequest: (id, note) => api.post(`/admin/requests/${id}/reject`, { note }),
  listDownloads: () => api.get('/admin/downloads'),
  downloadFile: (downloadId) => `${BACKEND_URL}/api/downloads/${downloadId}/file`,
  listPricing: () => api.get('/admin/pricing'),
  updatePricing: (provider, price_tl) => api.post('/admin/pricing', { provider, price_tl }),
  deletePricing: (provider) => api.delete(`/admin/pricing/${provider}`),
  getSettings: () => api.get('/admin/settings'),
  updateSettings: (patch) => api.post('/admin/settings', patch),
  listSupportTickets: (status) => api.get('/admin/support/tickets', { params: status ? { status } : {} }),
  replySupportTicket: (ticketId, message) => api.post(`/admin/support/tickets/${ticketId}/reply`, { message }),
  closeSupportTicket: (ticketId) => api.post(`/admin/support/tickets/${ticketId}/close`),
  listContactMessages: () => api.get('/admin/contact-messages'),
  markContactRead: (messageId) => api.post(`/admin/contact-messages/${messageId}/read`),
  deleteContactMessage: (messageId) => api.delete(`/admin/contact-messages/${messageId}`),
};

export const supportAPI = {
  createTicket: (subject, message) => api.post('/support/tickets', { subject, message }),
  myTickets: () => api.get('/support/tickets'),
};

export const toolsAPI = {
  getResizeSettings: () => api.get('/tools/resize-settings'),
};

export const passwordAPI = {
  forgot: (email) => api.post('/auth/forgot-password', { email }),
  reset: (token, password) => api.post('/auth/reset-password', { token, password }),
};

export default api;

